export default {
  //下载中心banner
  downloadBanner: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/download/download-banner.vue'));
    }, '/modules/download/download-banner');
  },
  //下载中心列表
  downloadList: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/download/list.vue'));
    }, '/modules/download/list');
  }
}



// WEBPACK FOOTER //
// ./src/router/modules/download.js